/**
 * 水印
 * @description 使用 v-watermark 调用指令，会在指定元素的内容增加一个 watermark 的元素；
 */
import watermark from '@/libs/watermark';

export const watermarkDirective =  {
  bind: (el, binding) => {
    watermark(el, binding.value || {});
  }
}
